import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
import { ExperimentPivots, ExperimentViewConstants } from "./experiment.constants.js";
const getResolveAlertRoute = ({ params }) => {
  return `${ROUTES.experiment.location.pathname}/${params.id}/${ExperimentPivots.alerts}/${ExperimentViewConstants.resolve}`;
};
const navigateToPivot = (experimentId, pivot) => {
  NavigationService.navigateTo(`${ROUTES.experiment.location.pathname}/${experimentId}/${pivot}`);
};
const navigateToExperiment = (experimentId) => {
  NavigationService.navigateTo(`${ROUTES.experiment.location.pathname}/${experimentId}`);
};
const navigateToAlerts = (experimentId) => {
  NavigationService.navigateTo(`${ROUTES.experiment.location.pathname}/${experimentId}/${ExperimentPivots.alerts}`);
};
const navigateToResolveAlerts = (experimentId) => {
  NavigationService.navigateTo(
    `${ROUTES.experiment.location.pathname}/${experimentId}/${ExperimentPivots.alerts}/${ExperimentViewConstants.resolve}`
  );
};
const getExperimentPath = (params) => {
  const { id, pivot } = params;
  return [id, pivot].reduce((acc, c) => !!c && !Object.keys(ExperimentViewConstants).includes(c) ? `${acc}/${c}` : `${acc}`);
};
const toggleEditView = (params, toggle = true) => {
  const path = getExperimentPath(params);
  const edit = toggle ? `/${ExperimentViewConstants.edit}` : "";
  NavigationService.navigateTo(`${ROUTES.experiment.location.pathname}/${path}${edit}`);
};
const toggleIterateView = (params, toggle = true) => {
  const path = getExperimentPath(params);
  const iterate = toggle ? `/${ExperimentViewConstants.iterate}` : "";
  NavigationService.navigateTo(`${ROUTES.experiment.location.pathname}/${path}${iterate}`);
};
export {
  getResolveAlertRoute,
  navigateToAlerts,
  navigateToExperiment,
  navigateToPivot,
  navigateToResolveAlerts,
  toggleEditView,
  toggleIterateView
};
//# sourceMappingURL=ExperimentRoute.utils.js.map
